import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { fetchBannerClose } from 'src/components/Search/Resume/ContextVacancy/api/bannerClose';
import { resumeSearchContextBannerClose } from 'src/models/resumeSearchContext';

export const useBannerClose = (): (() => void) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(resumeSearchContextBannerClose());
        void fetchBannerClose();
    }, [dispatch]);
};
